import {
  getAllMiniMenusApi,
  getSqsyMenuApi,
  updateMiniMenuApi,
  addMiniMenuApi,
  exchangeMiniMenuSortNumApi,
  deleteMiniMenuApi,
  setCompanyConfigApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  // 获取所有的小程序装修内容
  async getAllMiniMenusActions(context, param) {
    const res = await getAllMiniMenusApi(param)
    return res
  },
  // 获取[社区首页]数据
  async getSqsyMenuActions(context, param) {
    const res = await getSqsyMenuApi(param)
    return res
  },
  // 更新小程序菜单
  async updateMiniMenuActions(context, param) {
    const res = await updateMiniMenuApi(param)
    return res
  },
  // 删除小程序菜单
  async deleteMiniMenuActions(context, param) {
    const res = await deleteMiniMenuApi(param)
    return res
  },
  // 添加菜单
  async addMiniMenuActions(context, param) {
    const res = await addMiniMenuApi(param)
    return res
  },
  // 小程序排序
  async exchangeMiniMenuSortNumActions(context, param) {
    const res = await exchangeMiniMenuSortNumApi(param)
    return res
  },
  async setCompanyConfigActions({ rootState, rootGetters, commit }, param) {
    const res = await setCompanyConfigApi(param)
    let companyInfo = JSON.parse(JSON.stringify(rootGetters.companyInfo))
    companyInfo.companyConfig = param.companyConfig
    commit('setCompanyInfo', companyInfo)
    return res
  },
  functionAuth({ rootState }, data) {
    let brandInfo = ''
    if (rootState.isGSLogin) {
      brandInfo = rootState.brandList.filter(
        item => item.id === data.brandId
      )[0]
    } else {
      brandInfo = rootState.brandInfo
    }
    return brandInfo.functionAuth.some(item => item.type === data.type)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
